"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    display: 'inline-block',
    fontSize: palette.tsNormal,
    fontFamily: palette.fontFamily,
    lineHeight: 1.5,
    color: palette.tLabel,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    appearanceMargin: "0 ".concat(palette.gutter * 2, "px 0 0"),
    wordWrap: 'normal',
    whiteSpace: 'normal',
    rippleColor: '#000',
    iconColor: '#000',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    checkedColor: palette.tActive,
    checkedRippleColor: palette.elAccent,
    checkedIconColor: palette.elAccent,
    hoverColor: palette.tFilled,
    disabledColor: palette.tDisabled,
    errorColor: palette.tError
  };
}